import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const worlds = [
  { name: "Mercury", desc: "The energy furnace of civilization — solar infrastructure powering an entire interplanetary economy.", color: "border-orange-500/50 bg-orange-900/10" },
  { name: "Venus", desc: "Painstakingly terraformed over two centuries into an amber-skied world of warm oceans and black-sand beaches.", color: "border-amber-500/50 bg-amber-900/10" },
  { name: "Mars", desc: "Humanity's second home — red deserts giving way to domed cities and eventually open skies.", color: "border-red-500/50 bg-red-900/10" },
  { name: "The Belt", desc: "The 'Thousand Worlds' — fiercely independent Belters united by radical hospitality and orbital metaphors.", color: "border-gray-500/50 bg-gray-900/10" },
  { name: "Jupiter System", desc: "Europa, Ganymede, and Callisto — ice moons that fed Venus and raised questions about life beneath their surfaces.", color: "border-yellow-500/50 bg-yellow-900/10" },
  { name: "Triton / Neptune", desc: "Humanity's final harbor — a community of patient sentinels watching the boundary between solar system and interstellar void.", color: "border-blue-500/50 bg-blue-900/10" },
];

const SolarReborn = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5">
    <div className="max-w-6xl mx-auto px-6 lg:px-8">
      <SectionHeading title="A Solar System Reborn" subtitle="Act II" />
      <p className="text-gray-400 text-center max-w-3xl mx-auto mb-12 text-lg leading-relaxed">
        What follows is nothing less than the complete transformation of the solar system over four and a half centuries. Each chapter reads as its own world-within-a-world.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {worlds.map((world, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            className={`border rounded-2xl p-6 ${world.color} hover:scale-[1.02] transition-transform duration-300`}
          >
            <h3 className="text-white font-display font-bold text-xl mb-3">{world.name}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{world.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SolarReborn;